module.exports = __webpack_public_path__ + "static/EWY_Shar_social-cover-ed8dd5e0a5a2d8d46007973d6006f590.png";